/** One step of a process: its number, a short title, and what happens. */
interface ProcessStep {
  step: number;
  title: string;
  description: string;
}

/** Type and lines on the dark band: light type in the band's own foreground colour. */
const DARK_TONE = {
    body: "jobsite:text-primary-foreground/75",
    card: "jobsite:border-primary-foreground/15 jobsite:bg-primary-foreground/5",
    line: "jobsite:bg-primary-foreground/20",
    title: "jobsite:text-primary-foreground",
  },

  /**
   * A list key for a step: its number and title, which the owner keeps distinct.
   * @param {ProcessStep} step The step.
   * @returns {string} The key.
   */
  stepKey = (step: ProcessStep): string => `${step.step}-${step.title}`;

export type { ProcessStep };
export { DARK_TONE, stepKey };
